@if (breadcrumb?.length > 1) {
  <sd-breadcrumb
    [breadcrumb]="breadcrumb"
    [separator]="separator"
    (clickNavigation)="onClickLink($event)"
    />
}

<span [wcCxJsonLd]="snippetsBreadCrumb"></span>
